import { render } from "./ProjectSelectionItem.vue?vue&type=template&id=108af3ed&ts=true"
import script from "./ProjectSelectionItem.vue?vue&type=script&lang=ts"
export * from "./ProjectSelectionItem.vue?vue&type=script&lang=ts"

import "./ProjectSelectionItem.vue?vue&type=style&index=0&id=108af3ed&lang=css"

import exportComponent from "/home/nick/programming/zed-projects/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__